import Url from "../lib/url.js";
import TokenStorage from "./token-storage.js";
import Application from "./application.js";
import Semaphore from "../lib/semaphore.js";

let currentIs = pages => {
    if (!Array.isArray(pages)) {
        pages = [pages];
    }
    let path = new Url().getPath() || "";
    if (path.indexOf(".html") < 0) {
        path = "/index.html";
    }
    for (let i=0; i<pages.length; i++) {
        if (path.indexOf(pages[i] + ".html") >= 0) {
            return true;
        }
    }
    return false;
};

export default {
    data() {
        return {
            logined: false,
            currentUser: null,
            userSemaphore: null,
            operations: [{
                label: "个人中心",
                click: () => {
                    if (!currentIs("i")) {
                        this.switchTo("i");
                    }
                }
            }, {
                label: "退出登录",
                click: this.logout
            }]
        }
    },
    computed: {
        user() {
            if (this.logined && this.currentUser) {
                return {
                    meta: this.currentUser,
                    operations: this.operations
                }
            } else {
                return {
                    meta: {},
                    operations: []
                }
            }
        }
    },
    async created() {
        this.userSemaphore = new Semaphore();
        
        if (Application.mock.login) {
            this.currentUser = {
                id: 1,
                username: "mock"
            };
            this.logined = true;
            this.userSemaphore.release();
            return;
        }
        this.logined = await this.$remotes.server.auth.isLogin();
        if (!this.logined) {
            this.userSemaphore.release();
            return;
        }
        
        let user = await this.$remotes.server.mine.getInfo();
        user.avatar = this.$remotes.server.mine.$getAvatarUrl(user.avatar);
        this.currentUser = user;

        // 根据roles追加菜单
        let roles = await this.$remotes.server.auth.getRoles();
        if (roles.length <= 1) {
            this.logined = true;
            return;
        }
        let switchOperations = {
            label: "切换到",
            operations: []
        };
        this.operations.splice(1, 0, switchOperations);
        if (roles.indexOf("APP_USER") >= 0 && !currentIs(["index", "auth"])) {
            switchOperations.operations.push({
                label: "用户",
                click: () => {
                    this.switchTo("index");
                }
            });
        }
        if (roles.indexOf("SERVICER") >= 0 && !currentIs("servicer")) {
            switchOperations.operations.push({
                label: "服务商",
                click: () => {
                    this.switchTo("servicer");
                }
            });
        }
        if (roles.indexOf("ADMIN") >= 0 && !currentIs("admin")) {
            switchOperations.operations.push({
                label: "管理员",
                click: () => {
                    this.switchTo("admin");
                }
            });
        }

        this.logined = true;
        this.userSemaphore.release();
    },
    methods: {
        login() {
            let nowUrl = Url.encode(window.location.href);
            window.location.href = "login.html?redirect-url=" + nowUrl;
        },
        logout() {
            TokenStorage.clear();
            this.logined = false;
            this.currentUser = null;
            window.location.href = "login.html";
        },
        switchTo(page) {
            window.location.href = page + ".html";
        },
        hasPermission(permission) {
            if (typeof permission == "object") {
                permission = permission.meta;
            }
            return this.logined && this.currentUser.permissions.indexOf(permission) >= 0;
        }
    }
};